export const serviceOne = {
    icon: require('../../Images/svg-3.svg').default,
    heading: 'Business Intelligence & AI Software',
    desc: 'We uses predictive analytics tools to build business intelligence (BI) software solutions from scratch or integrate into existing business environments, including tools that focus on delivering self-service capabilities, enabling decision-makers to recognize performance gaps, and reducing IT dependencies.',
};

export const serviceTwo = {
    icon: require('../../Images/svg-1.svg').default,
    heading: 'Intelligent Document Recognition',
    desc: 'Our expert software developers and engineers build intelligent, robust, and reliable document recognition software, designed to quickly extract metadata and classify information from a wide range of document types, that enables users to search for documents easily on a centralized platform.',
};

export const serviceThree = {
    icon: require('../../Images/svg-2.svg').default,
    heading: 'Natural Language Processing',
    desc: 'We program Natural Language Processing (NLP) software solutions to analyze structured and semi-structured content, including search queries, mined web data, business data repositories, and audio sources to detect emerging trends, provide operational insights, and perform predictive analytics.',
};